import { render, staticRenderFns } from "./AccidentRule.vue?vue&type=template&id=50fcaeb6&scoped=true"
import script from "./AccidentRule.vue?vue&type=script&setup=true&lang=js"
export * from "./AccidentRule.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AccidentRule.vue?vue&type=style&index=0&id=50fcaeb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fcaeb6",
  null
  
)

export default component.exports